import { SVGProps } from "react";

const ArrowSwapIcon = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.66626 13.3333L7.16626 15.8333M7.16626 15.8333L4.66626 13.3333M7.16626 15.8333V4.16667M11.3329 6.66667L13.8329 4.16667M13.8329 4.16667L16.3329 6.66667M13.8329 4.16667V15.8333"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowSwapIcon;
